<template>
  <component
    :key="`${card.component}.${card.uriKey}`"
    class="h-full"
    :class="[widthClass, heightClass]"
    :is="card.component"
    :card="card"
    :resource="resource"
    :resourceName="resourceName"
    :resourceId="resourceId"
    :lens="lens"

  />
</template>

<script>
function widthClassHelper(short) {
    return {
        full: 'col-span-12',
        '1/3': 'col-span-4',
        '1/2': 'col-span-6',
        '1/4': 'col-span-3',
        '2/3': 'col-span-8',
        '3/4': 'col-span-9',
    }[short] ?? short
}

export default {
  props: {
    card: {
      type: Object,
      required: true,
    },

    resource: {
      type: Object,
      required: false,
    },

    resourceName: {
      type: String,
      default: '',
    },

    resourceId: {
      type: [Number, String],
      default: '',
    },

    lens: {
      lens: String,
      default: '',
    },
  },

  computed: {
    /**
     * The class given to the card wrappers based on its width
     * Extended to allow reactive widths, e.g.:
     *      $width='2/3 lg:1/3 xl:col-span-2'
     * would evaluate to 'md:col-span-8 lg:col-span-4 xl:col-span-2'
     */
    widthClass() {
        const classes = [];
        for (const cls of this.card.width.split(' ')) {
            const prefixes = cls.split(':')
            if (prefixes.length === 1) {
                classes.push('md:' + (widthClassHelper(prefixes[0])))
            }
            else {
                classes.push(
                    [
                        ..._.slice(prefixes, 0, -1),
                        widthClassHelper(_.slice(prefixes, -1)[0])
                    ].join(':'))
            }
        }
        return classes.join(' ')
    },

    heightClass() {
      return this.card.height === 'fixed' ? 'min-h-40' : this.card.height
    },
  },
}
</script>
